import React from "react";
import Publication from "./Publication";
import { Col, Container, Row } from "react-bootstrap";

const Publications = (props) => {
  const { publications } = props;
  return (
    <>
      {" "}
      <h2 className="heading">Publications</h2>
      {publications.map((value, index) => {
        return <Publication {...value} />;
      })}
    </>
  );
};

export default Publications;
